module.exports = __webpack_public_path__ + "img/cotImage.60539223.svg";